import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";

const Histroy = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">ForkLift Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/History">
                <div className="kor">주요사업이력</div>
                <div className="eng">Major business history</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"지게차 사업 / 주요 사업 이력"}
              titleeng={"Forklift business / Major business history"}
            />
            <S.HistoryTable class="history-table">
              <div class="history-table-head">
                <div class="history-table-ceil-small">
                  <div className="kor">구분</div>
                  <div className="eng">Year</div>
                </div>
                <div class="history-table-ceil-big">
                  <div className="kor">주요 사업내용</div>
                  <div className="eng">Major business history</div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1903</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      클라크 설립 / Geoge R, Rich Manufacturing Company (미국
                      미시간 주) / 클라크 지게차의 모체로 자동차용 부품 생산
                    </div>
                    <div className="eng">
                      03 Establishing Geoge R, Rich Manufacturing Company (
                      Michigan, USA) <br /> / Automotive parts production, as a
                      mother of Clark forklifts
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1917</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Clark Equipment Company가 세계 최초 엔진식 산업용 지게차
                      Tructractor 개발 및 생산
                    </div>
                    <div className="eng">
                      Clark Equipment Company developed the world's first
                      industrial truck with an <br /> internal combustion
                      engine, 'Tructractor'
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1919</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Clark Equipment Company의 지게차사업 전문 자회사로, Clark
                      Tructractor Company가 미시간 주 배틀크릭(Battle Creek)에
                      설립 / 지게차 사업부문 독립운영 시작
                    </div>
                    <div className="eng">
                      Clark Tructractor Company, a subsidiary of Clark Equipment
                      Company that specializes in <br />
                      forklift business, was established in Battle Creek,
                      Michigan <br />/ Started independent operation of forklift
                      business division
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1928</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      세계 최초로 유압식 리프트를 사용한 엔진식 지게차 Tructier
                      모델 런칭(현대 지게차 모델의 효시)
                    </div>
                    <div className="eng">
                      Launching of Tructier, the world's first engine-powered
                      forklift using a hydraulic lift <br /> (The first modern
                      forklift model)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1976</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">세계 최초로 50만 번째 지게차 생산</div>
                    <div className="eng">
                      Produced the 500,000th forklift as the first manufacturer
                      in the world
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1989</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      북미 및 유럽지역 지게차 사업부문 통합 / Clark Material
                      Handling Company로 상호 변경
                    </div>
                    <div className="eng">
                      Integration of forklift businesses in North America and
                      Europe <br /> / Clark Forklift Division renamed Clark
                      Material Handling Company
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1992</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Clark Equipment Company가 Clark Material Handling
                      Company를 Terex Corporatiopn에 매각
                    </div>
                    <div className="eng">
                      Clark Equipment Company sold Clark Material Handling
                      Company to Terex Corporation
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2000</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Clark Material Handling Company가 미 법원에 파산
                      신청(챕터11) / 독일법인, 한국법인도 법정관리 들어감
                    </div>
                    <div className="eng">
                      Clark Material Handling Company filed for bankruptcy in
                      U.S. court (Chapter 11) <br />/ German and Korean
                      affiliates also went into court receivership.
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2001</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">미국 렉싱턴 공장 폐업</div>
                    <div className="eng">
                      Closed down the Lexington, KY factory
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2003.1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      영안모자, Clark Material Handling Company (미국 본사) 인수
                    </div>
                    <div className="eng">
                      YoungAn Hat Company acquired CLARK Material Handling
                      Company (HQ-USA)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2003.5</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      영안모자, Clark Material Handling Asia(한국 법인) 인수
                    </div>
                    <div className="eng">
                      YoungAn Hat Company acquired CLARK Material Handling Asia
                      (Korea affiliate)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2004.7</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Material Handling International (CMHI) (주)클라크
                      설립 (한국) / 영안모자로부터 미국본사 및 한국법인 인수 및
                      클라크 전세계 법인의 지주회사 역할 수행 / 글로벌 본부 운영
                      체제 구축
                    </div>
                    <div className="eng">
                      Establishing CLARK Material Handling International (CMHI)
                      in Korea <br />
                      / Acquired CLARK Material Handling Company (CMHC, QH-USA)
                      and <br />
                      CLARK Material Handling Asia (CMHA, KR affiliate) from
                      YoungAn Hat Company and <br />
                      operating as a Holding company for CLARK affiliates
                      worldwide <br />/ Set up a Global HQ operating system
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2004.10</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Europe GmbH 신규 설립 및 독일법인 재가동 / 유럽,
                      중동, 아프리카 지역 판매 법인
                    </div>
                    <div className="eng">
                      Establishing CLARK Europe GmbH (CMHEU) in Germany <br /> /
                      Sales affiliate to Europe, Middle East, Africa
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2004.12</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Dabo Material Handling Equipment Brasil, S.A. 신규 설립 및
                      브라질 법인 재가동 / 브라질 지역 판매법인
                    </div>
                    <div className="eng">
                      Establishing Dabo Material Handling Equipment Brasil, S.A.{" "}
                      <br /> and restart of Brazilian affiliate (CMHBZ) / Sales
                      affiliate to the Brazilian market
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2005.7</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Material Handling Costa-Rica 코스타리카 법인 설립/
                      중미지역 판매법인
                    </div>
                    <div className="eng">
                      Establishing CLARK Material Handling Costa-Rica (CMHCR){" "}
                      <br /> / Sales affiliate to the Central American market
                    </div>
                  </div>

                  <div class="line"></div>
                  <div class="ceil-kor">
                    <div className="kor">
                      Qingdao CLARK Material Handling Co., Ltd. 신규 설립 / 중국
                      생산법인
                    </div>
                    <div className="eng">
                      Establishing Qingdao CLARK Material Handling Co., Ltd.
                      (CMHCN) <br /> / Manufacturing affiliate in China
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2006.3</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Material Handling Company의 렉싱턴 공장 재가동 /
                      미국 생산 재개
                    </div>
                    <div className="eng">
                      Restart of factory operation in CLARK Material Handling
                      Company <br /> / Restart of U.S. production
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2007.1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Qingdao CLARK Material Handling Co., Ltd. / 중국 공장
                      지게차 양산 시작
                    </div>
                    <div className="eng">
                      Qingdao CLARK Material Handling Co., Ltd. / Start of mass
                      production in China
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2009.9</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK France S.A.R.L 신규 설립 및 프랑스 법인 재가동 /
                      프랑스어권 지역 판매법인
                    </div>
                    <div className="eng">
                      Establishing CLARK France S.A.R.L (CMHFR) and restarting
                      the French affiliate <br /> / Sales affiliate to
                      French-speaking regions
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2011.1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK International South Pacific Pty Ltd. 신규 설립 및
                      호주 법인 재가동 / 호아주 지역 판매법인
                    </div>
                    <div className="eng">
                      Establishing CLARK International South Pacific Pty Ltd.
                      and restart of Australian affiliate <br /> / Sales
                      affiliate to Oceania
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2011.3</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Material Handling Mexico S.A. 신규 설립 및 멕시코
                      생산법인 재가동
                    </div>
                    <div className="eng">
                      Establishing CLARK Material Handling Mexico S.A. and
                      restart of <br /> Mexico production affiliate operation
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2014.5</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Europe GmbH 가 뒤스부르크에 신건물 매입 및 이전 /
                      유럽본부 운영 시작
                    </div>
                    <div className="eng">
                      CLARK Europe GmbH (CMHEU) purchased a new building and
                      relocated to Duisburg <br /> / Started European HQ
                      operation
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2016.1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Material Handling Mexico S.A. (CMHMX) 판매법인으로
                      전환
                    </div>
                    <div className="eng">
                      CLARK Material Handling Mexico S.A. (CMHMX) changed to
                      sales affiliate
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2016.5</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      미국공장 및 멕시코공장, 미국으로 통합 / 미국공장 생산 확대
                    </div>
                    <div className="eng">
                      US and Mexico factories integrate into US / US factory
                      expansion
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2017.5</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      지게차 최초 개발 100주년 행사 진행 (미국 렉싱턴 및 전세계)
                    </div>
                    <div className="eng">
                      100th anniversary of the world's first forklift
                      development <br /> (Lexington, KY, USA and worldwide)
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2017.8</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Dabo Material Handling Equipment Brasil, S.A. (CMHBZ)의
                      사명을 CLARK Material Handling Brasil, S.A. 으로 변경
                    </div>
                    <div className="eng">
                      Dabo Material Handling Equipment Brasil, S.A. renamed{" "}
                      <br /> CLARK Material Handling Brasil, S.A.
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2018.3</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK International Singapore Pte Ltd 싱가폴 법인 신규
                      설립 / 아시아지역 판매법인
                    </div>
                    <div className="eng">
                      Establishing CLARK International Singapore Pte Ltd.
                      (CMHSQ) <br /> / Sales affiliate to the Asian market
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2019.4</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK Material Handling Vietnam Co., Ltd. (CMHVN) 지게차
                      양산 시작
                    </div>
                    <div className="eng">
                      CLARK Material Handling Vietnam Co., Ltd. / Start of mass
                      production in Vietnam
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2020.6</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      CLARK-BOOGOOK Vietnam Co., Ltd (CBVN) 베트남 부품생산
                      합자법인 설립
                    </div>
                    <div className="eng">
                      Establishing CLARK-BOOGOOK Vietnam Co., Ltd. (CBVN) <br />{" "}
                      / JV of parts production in Vietnam
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2021.1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Qingdao CLARK Trading Co., Ltd 중국 무역법인 설립 / 글로벌
                      부품소싱 공급기지 역할 수행
                    </div>
                    <div className="eng">
                      Establishing Qingdao CLARK Trading Co., Ltd. / Trading
                      affiliate in China <br /> / Global parts sourcing &
                      distribution center
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line last-line">
                <div class="history-table-ceil-small">2022.1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      클라크 글로벌 본부 미국으로 재이전 / 클라크 미국 본사와
                      통합운영 시작 (텍사스주 달라스)
                    </div>
                    <div className="eng">
                      Global HQ relocated to the US / Started integrated
                      operations with CLARK USA HQ <br /> (Dallas, Texas)
                    </div>
                  </div>
                </div>
              </div>
            </S.HistoryTable>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Histroy;
